const IN_PROGRESS = new Set([
  'starting',
  'fetch',
  'write',
  'load',
  'validate',
  'parse',
  'labels',
  'indicators',
  'render',
  'write-xlsx',
  'register',
  'packages',
  'micropip',
  'import',
  'loading',
]);

const LABELS: Record<string, string> = {
  idle: 'Idle',
  starting: 'Starting',
  fetch: 'Loading filing',
  write: 'Writing to worker',
  load: 'Loading taxonomy',
  validate: 'Validating',
  parse: 'Parsing instance',
  labels: 'Building labels',
  indicators: 'Reading filing indicators',
  render: 'Rendering reports',
  'write-xlsx': 'Building Excel file',
  register: 'Registering taxonomy',
  packages: 'Loading packages',
  micropip: 'Installing dependencies',
  import: 'Importing Arelle',
  loading: 'Loading Pyodide',
  ready: 'Ready',
  error: 'Error',
  unsupported: 'Not supported',
};

export function formatJobStatusLabel(phase: string | null | undefined): string | null {
  if (!phase || phase === 'idle') {
    return null;
  }
  return LABELS[phase] ?? phase.replace(/-/g, ' ');
}

export function isInProgressJobPhase(phase: string | null | undefined): boolean {
  return !!phase && IN_PROGRESS.has(phase);
}
